import React from 'react'
import {
    Container
} from 'reactstrap'

import Breadcrumbs from '../../components/Common/Breadcrumb'
import DataTable from './components/Datatable'

//i18n
import { withNamespaces } from "react-i18next"

const Index = () => {
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs
                        title="Pedidos"
                        breadcrumbItem={`Pedidos`}
                        parentLink={`/pedidos`}
                    />
                    <DataTable />
                </Container>
            </div>
        </React.Fragment>
    )
}

export default withNamespaces()(Index)
